// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__QcJnh","header":"MessagesList_header__2uuvN","chat":"MessagesList_chat__3YEJI"};